import { render, staticRenderFns } from "./TableGeneric.vue?vue&type=template&id=37e4cca8&scoped=true"
import script from "./TableGeneric.vue?vue&type=script&lang=ts"
export * from "./TableGeneric.vue?vue&type=script&lang=ts"
import style0 from "./TableGeneric.vue?vue&type=style&index=0&id=37e4cca8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e4cca8",
  null
  
)

export default component.exports